import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postCanceled = (params) => {
    return axios.post(`${backendHost}/api/admin/freespin/canceled`, params);
};

export {
    postCanceled
}